import React, { useState, useCallback, forwardRef, MouseEventHandler } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Content from './Content';
import Tooltip from 'vibo-ui/Tooltip';
import Dropdown from 'vibo-ui/Dropdown';
import IconButton from 'components/buttons/IconButton';

import { SongCommentProps } from './interfaces';
import { ButtonIconType } from 'types/enums';

import useIconButtonDecStyles from 'components/buttons/IconButton/decorStyle';
import useStyles from './style';

const SongComment = forwardRef<HTMLDivElement, SongCommentProps<SectionSong>>(
  ({ song, className }, ref) => {
    const iconButtonDecClasses = useIconButtonDecStyles();
    const classes = useStyles();
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    const handleClick: MouseEventHandler<HTMLDivElement> = e => e.currentTarget.focus();

    const handleClose = useCallback(() => {
      setIsOpen(false);
    }, [isOpen]);

    return (
      <div
        className={classNames('songComment', classes.songComment, className)}
        onClick={handleClick}
        ref={ref}
      >
        <Dropdown
          overlay={<Content song={song} handleClose={handleClose} />}
          onVisibleChange={setIsOpen}
          visible={isOpen}
          trigger="click"
          key={`${isOpen}${song?._id}`}
        >
          <Tooltip
            className={classNames(classes.commentText, {
              [classes.addCommentText]: !song?.comment,
            })}
            overlay={song?.comment || t('addComment')}
            placement="top"
            {...(isOpen ? { visible: false } : {})}
            destroyTooltipOnHide
          >
            <IconButton
              type={ButtonIconType.comment}
              className={classNames(iconButtonDecClasses.highlighted, {
                songCommentIcon: !isOpen,
              })}
              placement="top"
              data-gtm-target-id="timeline-section-details-songs-song-add-comment"
            />
          </Tooltip>
        </Dropdown>
      </div>
    );
  }
);

export default SongComment;
